import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../components/ui/avatar";
import { Card, CardContent } from "../../components/ui/card";
import CustomButton from "../../components/customButton";
import { useNavigate } from "react-router-dom";
import useCartDetail from "../../store/cart/getcartDetails";
import axios from "axios";
import useStoreQuantite from "../livraison/store";
import Loader from "../../components/loader";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../components/Breadcrumb";
import { FaArrowLeft } from "react-icons/fa";
import { formatNombre, scrollToTop } from "../../lib/utils";
import { URL } from "../../lib/apis";

const Cart = () => {
  const { fetchAllCat } = useCartDetail(
    (state) => state
  );
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("user");
  const { t, i18n } = useTranslation()
  const [carts, setCarts] = useState<unknown[]>([])
  // eslint-disable-next-line
  const [totalPrice, setTotalprice] = useState(0)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [loader, setLoader] = useState(false)

  const { quantitee } = useStoreQuantite();
  // console.log("quantitee", cartDetails)
  const updateCart = async () => {
    try {
      fetchAllCat()
      const { data } = await axios.get(`${URL}/cart-details/users/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      console.log(data)
      if (data) {
        // Calculate the total price
        const price = data?.data.reduce((total: any, item: any) => {
          const productTotal = parseFloat(item.product.price) * quantitee;
          return total + productTotal;
        }, 0);
        setTotalprice(price)
        const myCart = Object.values(data?.data.reduce((acc: any, carte: any) => {
          (acc[carte.product.producer_name] = acc[carte.product.producer_name] || []).push(carte)
          return acc
        }, {}))
        setCarts(myCart)
        setLoading(false)
      } else {
        // toast.warning("Vous n'avez pas de produit dans votre panier")
        console.log("laaaa")
        setCarts([])
      }
    } catch (error: any) {
      if (error.response?.status === 404) {
        setCarts([])
      }
      if (error.response) {
        toast.error(i18n.language === "fr" ? error.response.data.message : error.response.data.messageE)
      }

      console.log(error)
    } finally {
      setLoading(false)
    }

  }

  useEffect(() => {
    scrollToTop()
  }, [])

  if (!token) {
    throw new Error("User is not authenticated");
  }

  useEffect(() => {
    updateCart()
    // eslint-disable-next-line
  }, []);

  // Function to delete a product from the cart
  const deleteProductFromCart = (productId: number) => {
    setLoader(true)
    const config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${URL}/cart/${productId}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Product removed:", response.data);

        updateCart();
        setLoader(false)
      })
      .catch((error) => {
        setLoader(false)
        toast.error(i18n.language === "fr" ? error.response.data.message : error.response.data.messageE)
        console.log("Error removing product:", error);
      });

  };

  const calculPrix = (item: any) => {
    let prix = 0
    item.forEach((produit: any) => {
      prix += Number(produit.product.price * produit.quantity)
    })
    return formatNombre(prix)
  }

  return (
    <div className="py-5 px-8 bg-softGrey flex-col h-full flex">
      <div className="flex flex-row py-5  items-center justify-start w-full ml-5">

        <Breadcrumb />
      </div>
      <div className="w-full mt-3 flex flex-col gap-2">
        <h1 className="text-[22px] font-normal">{t("mon_panier")}</h1>
        <div className="px-2 text-[13px] font-normal border-third border-solid rounded-[5px] border-y-[4px] border-x-[10px] max-w-[800px]">
          {t('text_panier')} !!!
        </div>

        <div className="flex gap-3 w-full ">

          {loading ? <Loader /> :
            <CardContent className=" p-0  w-full">
              <Accordion className="w-full" defaultValue="item-0" type="single" collapsible>
                <div className=" grid md:grid-cols-2 grid-cols-1 space-y-3  md:space-x-5" >
                  {carts?.map((item: any, index: any) => (
                    <Card className="md:w-[95%] w-full p-5 md:m-5 mb-1" >
                      <AccordionItem value={`item-${index}`}>
                        <AccordionTrigger className="w-full">
                          <div className="flex flex-col  justify-between items-center">
                            <div className="flex gap-8 items-center text-grey">
                              <Avatar className="w-[78px] bg-gray-700 h-[78px]">
                                <AvatarImage
                                  src={item[0].product.producer_profile_image_url}
                                  alt={item[0].product.producer_name[0]}
                                />
                                <AvatarFallback>
                                  {item[0].product.producer_name.slice(0, 2)}
                                </AvatarFallback>
                              </Avatar>

                              <div className="flex flex-col gap-1 text-[12px] font-normal items-start">
                                <div>
                                  <span className="text-grey">{t("vendu_par")}:</span>
                                  <span> {item[0].product.producer_name}</span>
                                </div>
                                <span>{t("produit")}: {item.length}</span>
                              </div>
                            </div>
                            <div>
                              <span>{t("prix_total")}: {calculPrix(item)} FCFA</span>
                            </div>
                            <div className="flex w-[70%] md:w-auto flex-row items-center justify-center">
                              <CustomButton onClick={() => {
                                navigate("/Adresse_Livraison", { state: item })
                              }} rounded className="bg-primary w-[100%] text-white px-4 py-2">
                                {t("passer_commande")}
                              </CustomButton>
                              <div className="h-[24px] ml-3 w-[24px] rounded-full border-black border-solid border-[1px] flex justify-center items-center">
                                <img
                                  className="h-[13px] w-[13px]"
                                  src="/chevronDown.svg"
                                  alt=""
                                />
                              </div>
                            </div>




                          </div>
                          <div className="h-[1px] w-full bg-primary my-3"></div>
                        </AccordionTrigger>
                        {
                          item.map((product: any, index: number) => {
                            return (
                              <AccordionContent>
                                <div className="flex flex-col gap-3">
                                  <div key={index}>
                                    <div className="flex flex-col md:flex-row items-center gap-4">
                                      {/* <Checkbox /> */}
                                      <div className="rounded-[5px] h-[139px] w-[149px]">
                                        <img
                                          className="h-full w-full object-contain"
                                          src={JSON.parse(product.product.images)[0]} // Show the first image
                                          alt={product.product.product_name}
                                        />
                                      </div>
                                      <div className="flex md:flex-row flex-col w-full justify-between">
                                        <div className="flex flex-col gap-1">
                                          <div className="flex flex-col">
                                            <span className="text-[15px] font-bold">
                                              {i18n.language === "fr" ? product.product.product_name : product.product.product_name_en}
                                            </span>
                                            <span className="text-[15px]">
                                              {t("variete")}: {product.product.variety}
                                            </span>
                                          </div>
                                          <div>
                                            <span className="text-[10px] text-grey">
                                              {t("quantite_min")}:{" "}
                                              {product.product.minimum_quantity}
                                            </span>
                                            <div className="bg-[#F5F5F5] w-[210px] h-[26px] rounded-[5px] flex">
                                              <div className="w-full flex justify-between items-center">
                                                <span className="text-[12px] text-grey ml-3">
                                                  {t("quantite")}
                                                </span>
                                                {/* <span
                                                className="h-full border-[#EBEBEB] border-solid border-r-[1px] w-[29px] flex items-center justify-center cursor-pointer"
                                                onClick={() =>
                                                  setQuantitee(quantitee - 1)
                                                }
                                              >
                                                -
                                              </span> */}
                                              </div>
                                              <span className="text-[15px] h-full border-[#EBEBEB] border-solid border-r-[1px] w-[29px] flex items-center justify-center">
                                                {product.quantity}
                                              </span>
                                              {/* <span
                                              className="text-primary text-[12px] w-[29px] flex items-center justify-center cursor-pointer"
                                              onClick={() =>
                                                setQuantitee(quantitee + 1)
                                              }
                                            >
                                              +
                                            </span> */}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex flex-col justify-between">
                                          <div>
                                            <span className="text-[13px]">
                                              {t("prix_total")}:
                                            </span>
                                            <span className="text-third ml-1 text-[15px] font-bold">
                                              {formatNombre(parseInt(product.product.price) * product.quantity)}F
                                            </span>
                                          </div>
                                          <CustomButton
                                            rounded className="bg-secondary text-white px-4 py-2"
                                            onClick={() => deleteProductFromCart(product.cart_id)}
                                          >
                                            {loader ? "suppression..." : t("supprimer")}
                                          </CustomButton>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </AccordionContent>
                            )
                          })
                        }
                        <div className="flex justify-end items-center">
                          <span className="text-xl font-bold">{t("prix_total")}: {calculPrix(item)} FCFA</span>
                        </div>
                        <div className="h-[5px] w-full bg-slate-950 my-7"></div>
                      </AccordionItem>
                    </Card>
                  ))}
                </div>
              </Accordion>
            </CardContent>
          }



        </div>
      </div>
      <ToastContainer position="top-center" />
    </div>
  );
};

export default Cart;
